import { render } from "./Typographie.vue?vue&type=template&id=ef078576&scoped=true"
import script from "./Typographie.vue?vue&type=script&lang=js"
export * from "./Typographie.vue?vue&type=script&lang=js"

import "./Typographie.vue?vue&type=style&index=0&id=ef078576&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef078576"]])

export default __exports__